import { FC } from 'react';
import { ProgressBar } from 'src/components/UI/ProgressBar.tsx';
import { Agent } from 'src/types/agents.ts';
import IconCopy from 'src/assets/images/copy-icon.svg?react';
import toast from 'react-hot-toast';
import { UIInput } from 'src/components/UI/UIInput.tsx';
import { shortenHash } from 'src/utils/ui.ts';
import { BN } from 'src/utils/bigNumber.ts';

interface BondingCurve {
  agent: Agent;
}

export const BondingCurve: FC<BondingCurve> = ({ agent }) => {
  function handleCopy() {
    navigator.clipboard.writeText(agent.contract_address || '');
    toast.success('Address copied to clipboard!');
  }

  const progress = BN(agent.token_info?.progress || 0).toFixed(4);

  return (
    <div className="flex flex-col rounded-3xl bg-[#1A1C1E] px-6 py-6">
      <div className="mb-6 flex items-center justify-between">
        <span className="text-lg font-semibold">Bonding curve</span>
        <span className="text-sm opacity-50">{progress}%</span>
      </div>
      <ProgressBar progress={progress} />
      {agent.contract_address && (
        <div onClick={handleCopy}>
          <UIInput
            name="contract_address"
            containerClasses="w-full pt-0 pb-0"
            placeholder={shortenHash(agent.contract_address || '')}
            value={null}
            onChange={() => {}}
            disabled
            endAdornment={<IconCopy className="mr-3" />}
          />
        </div>
      )}
    </div>
  );
};
